import React from 'react';
import { useTranslation } from 'react-i18next';
import { DropDown } from '@/components/design-system/molecules/dropdown';
import { useVacancyMaintenanceFiltersContext } from '../../../../hooks/use-vacancy-maintenance-filters';

const VacancyStatusDropDown = () => {
  const { selectedVacancyStatus, setSelectedVacancyStatus } = useVacancyMaintenanceFiltersContext();
  const { t } = useTranslation();

  const statusOptions = [
    { value: 'vacant', label: t('js.features.admin.stats.dashboard.vacancy.vacant') },
    { value: 'maintenance', label: t('js.features.admin.stats.dashboard.vacancy.maintenance') },
  ];

  return (
    <DropDown
      placeholder={t('js.features.admin.stats.dashboard.vacancy.status.placeholder')}
      className="z-50 w-full max-w-[200px]"
      showLabel
      value={selectedVacancyStatus}
      onChange={setSelectedVacancyStatus}
      displayValue={statusOptions.find((opt) => opt.value === selectedVacancyStatus)?.label}
    >
      <DropDown.DropDownOptions>
        {statusOptions.map((option) => (
          <DropDown.DropDownOption key={option.value} value={option.value}>
            <DropDown.DropDownOptionDefaultContent>
              {option.label}
            </DropDown.DropDownOptionDefaultContent>
          </DropDown.DropDownOption>
        ))}
      </DropDown.DropDownOptions>
    </DropDown>
  );
};

export { VacancyStatusDropDown };
